import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { cn } from '@shared/utils/utils';

import { DropdownMenuItem } from './DropdownMenu';

export interface DropdownMenuLinkItemProps
  extends Omit<React.ComponentPropsWithoutRef<typeof DropdownMenuItem>, 'onClick' | 'asChild'> {
  to: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const DropdownMenuLinkItem = React.forwardRef<HTMLAnchorElement, DropdownMenuLinkItemProps>(
  ({ to, className, children, onClick, ...props }, ref) => {
    const navigate = useNavigate();

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
      onClick?.(event);
      if (event.defaultPrevented) {
        return;
      }

      // Click normal: navegación SPA. Ctrl/Cmd+click o click con rueda: enlace nativo.
      if (!event.ctrlKey && !event.metaKey && event.button === 0) {
        event.preventDefault();
        navigate(to);
      }
    };

    return (
      <DropdownMenuItem asChild className={cn('whitespace-nowrap', className)} {...props}>
        <a
          ref={ref}
          href={to}
          className="flex w-full items-center gap-2 no-underline text-inherit"
          onClick={handleClick}
        >
          {children}
        </a>
      </DropdownMenuItem>
    );
  },
);

DropdownMenuLinkItem.displayName = 'DropdownMenuLinkItem';
